<template>
  <div>
    <navbar>
      <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
      <router-link id="link-company" :to="{ name: 'StartPage' }" class="navbar-brand">
        <small :class="display"></small>
        <b-popover id="popover-company" target="link-company" triggers="hover" :content="company ? company.nome : ''" offset="0" placement="bottom"></b-popover>
      </router-link>
      <ul class="nav navbar-nav navbar-nav-icons">
        <li class="nav-item d-md-down-none">
          <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarMinimize">&#9776;</a>
        </li>
        <li class="nav-item px-2 header-icon-fullscreen">
          <a class="nav-link" href="javascript:void(0)" @click="toggleFullScreen" @mousemove="showCompanies = false"><i class="fas fa-expand-arrows-alt" v-b-tooltip.hover :title="$lang.Common.Buttons.Fullscreen"></i></a>
        </li>
        <li class="nav-item px-2" v-if="!isExternalUser">
          <a class="nav-link" href="javascript:void(0)" @mousemove="showCompanies = true"  @click="showCompanies = true"><i class="fas fa-sitemap"></i></a>
        </li>
        <li class="nav-item px-2" v-if="appsDownload.length" @mousemove="showCompanies = false">
          <b-dropdown variant="link" no-caret class="apps-download-dropdown">
            <template #button-content>
              <i class="fas fa-download" v-b-tooltip.hover :title="$lang.Common.Buttons.AppsDownload"></i>
            </template>
            <b-dropdown-item v-for="sistema in appsDownload" :key="sistema.nome" :href="sistema.url" target="_blank">
              <span class="text-third">{{ sistema.nome }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="nav-item px-2" v-if="hasRole(roles.RW_OPER_PCI)" @mousemove="showCompanies = false">
          <b-dropdown variant="link" no-caret>
            <template #button-content>
              <i class="fas fa-chart-pie" v-b-tooltip.right.hover :title="$lang.Common.Buttons.PciDashboards"></i>
            </template>
            <b-dropdown-item href="https://app.powerbi.com/reportEmbed?reportId=479dbdd3-39b1-4091-ab2a-fe8e0bfc8dda&autoAuth=true&filterPaneEnabled=false&navContentPaneEnabled=false" target="_blank">
              <div>
                <i class="fas fa-chart-bar text-primary" style="font-size: 1.5em;"></i>
                <span class="mx-1 text-third">{{ $lang.Common.Buttons.PciSummary }}</span>
              </div>
            </b-dropdown-item>
            <b-dropdown-item href="https://app.powerbi.com/reportEmbed?reportId=a98df3df-5de6-4159-9e48-4419f38ecd2e&autoAuth=true&filterPaneEnabled=false&navContentPaneEnabled=false" target="_blank">
              <div>
                <i class="fas fa-chart-line text-primary" style="font-size: 1.5em;"></i>
                <span class="mx-1 text-third">{{ $lang.Common.Buttons.PciFinance }}</span>
              </div>
            </b-dropdown-item>
          </b-dropdown>
          <a class="nav-link" href="" target="_blank"></a>
        </li>
      </ul>
      <div class="ml-auto mr-auto d-none d-md-block">
        <h2 style="color: #fb3;" class="mt-auto mb-auto" v-if="staging" ><strong>{{ $lang.Common.AcceptanceEnvironment }}</strong></h2>
      </div>
      <ul class="nav navbar-nav">
        <li class="divider-vertical d-md-down-none"></li>
        <li class="nav-item d-sm-down-none">
          <div v-if="!(notifications && notifications.length)">
            <i class="far fa-bell" style="color: white; font-size: 1.5rem;"></i>
          </div>
          <b-dropdown v-else variant="link" no-caret class="px-2" :popper-opts="{ modifiers: { offset: { offset: '-5px, 15px' } } }" v-b-tooltip.hover :title="$lang.Common.Buttons.AlertsInformation">
            <template #button-content>
              <i class="fas fa-bell" style="color: #C7CB85; font-size: 1.5rem;"></i>
              <b-badge style="position: absolute; top:10px; right:7px; background-color:gray;">{{notifications.length}}</b-badge>
            </template>
            <b-dropdown-item v-for="obj in notifications" v-bind:key="obj.id">
              <div v-if="obj.dataLeitura" class="notification-card" >
                <div>{{ obj.titulo }}</div>
                <div class="notification-card-date">{{ obj.dataAcaoFormatada }}</div>
              </div>
              <div v-else class="notification-card notification-card-gradient"
                          style="font-weight: bolder;"
                          @click="showModal('notification-modal', obj)">
                <div>{{ obj.titulo }}</div>
                <div class="notification-card-date">{{ obj.dataAcaoFormatada }}</div>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="divider-vertical d-md-down-none"></li>
        <li class="nav-item d-sm-down-none">
          <b-dropdown variant="link" no-caret class="px-2" :popper-opts="{ modifiers: { offset: { offset: '-5px, 15px' } } }" v-b-tooltip.hover :title="$lang.Common.Buttons.Localisation">
            <template #button-content>
              <img class="flags" src="https://static.zopone.com.br/img/flags/Brazil.png" alt="" v-if="$lang.CurrentLanguage === 'pt-br'">
              <img class="flags" src="https://static.zopone.com.br/img/flags/Spain.png" alt="" v-if="$lang.CurrentLanguage === 'es'">
            </template>
            <b-dropdown-item href="#" @click="onChangeLanguage('ptBr')">
              <b-img class="flags mr-2" src="https://static.zopone.com.br/img/flags/Brazil.png" alt="Português (Brasil)"/> Português (Brasil)
            </b-dropdown-item>
            <b-dropdown-item href="#" @click="onChangeLanguage('es')">
              <b-img class="flags mr-2" src="https://static.zopone.com.br/img/flags/Spain.png" alt="Espanhol"/> Español
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <!-- <li class="nav-item d-sm-down-none">
          <a class="nav-link" href="javascript:void(0);"><i class="icon-bell"></i><span class="badge badge-pill badge-default">0</span></a>
        </li>
        <li class="divider-vertical d-md-down-none"></li>
        <li class="nav-item d-sm-down-none">
          <a class="nav-link" href="javascript:void(0);" @click="asideToggle"><i class="fas fa-comments"></i></a>
        </li>
        <li class="nav-item d-md-down-none">
          <a class="nav-link" href="javascript:void(0);"><i class="fas fa-envelope"></i></a>
        </li> -->
        <li class="divider-vertical d-md-down-none"></li>

        <b-dropdown variant="link" no-caret class="pl-2">
          <template slot="button-content">
             <b-avatar class="mr-1"></b-avatar>
            <!--<img :src="imgAvatar" class="rounded-circle border border-white bg-white" style="width: 32px;" :alt="AccountEmail">-->
            <span class="d-md-down-none avatar-name">{{ userInfo ? userInfo.nome : '' }}</span>
            <i class="fa fa-caret-down avatar-icon"></i>
          </template>
          <b-dropdown-item :to="{ name: 'MinhaConta' }"><i class="fas fa-user-edit"></i> {{ $lang.Menu.Common.MyAccount }}</b-dropdown-item>
          <b-dropdown-item href="javascript:void(0)" @click="onSettings"><i class="fas fa fa-cogs"></i> {{ $lang.Menu.Common.Settings }}</b-dropdown-item>
          <b-dropdown-item href="javascript:void(0)" @click="onSignOut"><i class="fas fa-sign-out-alt"></i> {{ $lang.Menu.Common.Exit }}</b-dropdown-item>
        </b-dropdown>

        <li class="pr5 d-md-down-none">&nbsp;</li>
        <!--
        <li class="nav-item d-md-down-none">
          <a class="nav-link navbar-toggler aside-menu-toggler" href="#" @click="asideToggle">&#9776;</a>
        </li>
        -->
      </ul>
    </navbar>
    <div id="header-companies" class="header-companies" v-if="showCompanies && !isExternalUser" @mousemove="showCompanies = true" @mouseleave="showCompanies = false">
      <div class="col-12 pt-3 text-left">
        <span class="header-companies-btn-close" @click="showCompanies = false"><i class="fa fa-times-circle" aria-hidden="true" v-b-tooltip.hover :title="'Fechar'"></i></span>
        <!-- ZC-88: empresas vêm do banco (empresa.selecionavel + perfil de acesso da conta), não mais do mapa fixo -->
        <span v-for="empresa in empresasSelecionaveis" :key="empresa.id" @click="onChangeCompany(empresa.codigoZ)" class="cursor-pointer">
          <b-avatar v-if="empresa.logo" rounded="lg" :src="staticURL + empresa.logo" class="mr-3 mb-3 b-avatar-company" size="6rem" v-b-popover.hover.bottom.v-info="{content: empresa.nomeFantasia || empresa.nome, container: '#header-companies'}" />
          <b-avatar v-else rounded="lg" :text="sigla(empresa.nomeFantasia || empresa.nome)" variant="light" class="mr-3 mb-3 b-avatar-company" size="6rem" v-b-popover.hover.bottom.v-info="{content: empresa.nomeFantasia || empresa.nome, container: '#header-companies'}" />
        </span>
      </div>
    </div>
    <!--v-b-modal-->
    <div>
      <b-modal id="notification-modal"
        v-bind:title="$lang.NotificationGroups.Notification"
        :ok-only="true"
        :ok-disabled="okDisable"
        :ok-title="okLabel"
        v-on:ok="onOk">
        <h5 class="modal-title">{{ this.notification.titulo }}</h5>
        <div class="modal-body" v-html="notification.descricao"></div>
        <p style="text-align:right;font-size: smaller;font-weight: bolder;font-style: italic;">
          {{ this.notification.dataAcaoFormatada }}
        </p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import Roles from '@/shared/utils/roles.js'
import router from '@/router'
import navbar from './Navbar'

import { actionTypes as CompanyActions } from '@/store/module/company/actions'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import { mapActions, mapGetters } from 'vuex'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'
import AccountRepository from '@/shared/http/repositories/access/account'
import CompanyRepository from '@/shared/http/repositories/configuration/company'
import appsDownload from '@/config/apps-download'
// import coreHub from '@/shared/core-hub'
// import pciHub from '@/shared/pci-hub'

export default {
  name: 'AppHeader',
  mixins: [ CompanyMixin, PermissionMixin ],
  data () {
    return {
      showCompanies: false,
      display: '',
      // imgAvatar: process.env.BaseURL + '/static/img/avatars/02.png',
      // AccountName: decodeURIComponent(escape(JWTService.GetTokenPayload().Name)), // decode_utf8 | http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
      // AccountEmail: JWTService.GetTokenPayload().Email,
      companySelected: null,
      branchSelected: null,
      notifications: [],
      roles: Roles,
      appsDownload,
      empresasSelecionaveis: [],
      staticURL: 'https://static.zopone.com.br/',
      notification: {},
      okLabel: '5',
      okDisable: true,
      okCounter: 5
    }
  },
  computed: {
    ...mapGetters('auth', ['userInfo']),
    // Usuário externo (cliente/parceiro) fica preso à própria empresa —
    // sem seletor de empresa do grupo Zopone no topbar.
    isExternalUser () {
      return !!(this.userInfo && this.userInfo.externa)
    },
    staging () {
      return process.env.APIBaseURL !== 'https://api.prod.zopone.com.br'
    }
  },
  components: {
    navbar
  },
  mounted () {
    // CoreHub.client.on('Notificacao', function () {
    //   AccountRepository.GetNotifications()
    //     .then(response => {
    //       if (response.data.code > 0) {
    //         this.notifications = response.data.data
    //       }
    //     })
    // })

    AccountRepository.GetNotifications()
      .then(response => {
        if (response.data.code > 0) {
          this.notifications = response.data.data
        }
      })

    if (!this.isExternalUser) {
      CompanyRepository.GetSelecionaveis()
        .then(response => {
          if (response.data.code > 0) {
            this.empresasSelecionaveis = response.data.data
          }
        })
    }

    // coreHub.start(() => {
    //   this.notifications.push({id: this.notifications.length, descricao: 'AEEEEEEEEEEEEEEEEEEE'})
    // })

    // pciHub.start((message) => {
    //   if (!message) {
    //     message = 'falhou!'
    //   }
    //   // message.grupoNotificacaoIds // string[]
    //   // message.dataHora // string "dd/MM/yyyy HH:mm" (GMT-3)
    //   // message.titulo //string
    //   for (let i = 0; i < message.grupoNotificacaoIds.length; i++) {
    //     if (this.userInfo.grupoNotificacaoIds.find(g => g === message.grupoNotificacaoIds[i])) {
    //       this.notifications.unshift({
    //         id: this.notifications.length,
    //         titulo: message.titulo,
    //         dataAcaoFormatada: message.dataHora
    //       })
    //       this.$bvToast.toast(message.titulo, {
    //         title: this.$lang.NotificationGroups.Notification,
    //         variant: 'info',
    //         solid: true,
    //         autoHideDelay: 5000,
    //         appendToast: true
    //       })
    //       break
    //     }
    //   }
    // })
  },
  methods: {
    ...mapActions(
      {
        signOut: authActions.SIGN_OUT
      }
    ),
    onSignOut () {
      this.signOut(router)
    },
    onSettings () {
      this.$emit('Settings')
    },
    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
      // this.display = 'none'
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    toggleFullScreen () {
      if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        // topMenuData.showSmall = true
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen()
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
        }
      } else {
        //  this.topMenuData.showSmall = false
        if (document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    // Empresa sem logo no bucket: avatar com as iniciais do nome
    sigla (nome) {
      return (nome || '').split(/\s+/).filter(Boolean).slice(0, 3).map(p => p[0]).join('').toUpperCase()
    },
    onChangeCompany (codigo) {
      this[CompanyActions.GET_COMPANY_BY_CODIGO](codigo)
        .then(() => {
          this.showCompanies = false
          if (this.$router.history.current.name !== 'StartPage') {
            this.$router.push({ name: 'StartPage' })
          }
        })
    },
    onChangeLanguage (lang) {
      localStorage.setItem('language', lang)
      this.$setLang(lang)
    },
    setModalOkButton (count) {
      this.okCounter = count
      if (this.okCounter === 0) {
        this.okLabel = 'OK'
      } else {
        this.okLabel = `${this.okCounter} seg`
        this.okDisable = true
      }
    },
    showModal (id, obj) {
      this.setModalOkButton(5)
      this.$bvModal.show(id)
      this.notification = obj

      const interval = setInterval(() => {
        if (this.okCounter !== 0) {
          this.okCounter--
          this.setModalOkButton(this.okCounter)
        }
      }, 1000)

      setTimeout(() => {
        this.okDisable = false
        clearInterval(interval)
      }, 5000)
    },
    onOk () {
      this.setModalOkButton(5)
      AccountRepository.UpdateNotification(this.notification.id, {
        dataLeitura: new Date().toJSON()
      }).then(() => {
        this.notifications = this.notifications.filter(n => n.id !== this.notification.id)
      })
    }
  }
}
</script>

<style scoped>
.b-avatar {
  background-color: #9a9da0;
}

.b-avatar-company {
  background-color: #fff;
}
</style>

<style>
#popover-company {
  margin-top: 20px;
}

/* Base SEMPRE ativa (qualquer aparelho/largura): navbar-nav sai do
   position:absolute do tema legado (que so previa 1 ul visivel no
   mobile) e o header nunca quebra linha — so a logo cede espaco.
   Sem isso o header quebra/empilha em qualquer janela estreita,
   inclusive notebook com tela touch reportando hover:none com
   mouse plugado (motivo de nao depender so de "hover" aqui). */
.app-header.navbar {
  flex-wrap: nowrap;
}
/* Brand NAO estica: a logo e background-position:50% 50%, entao
   brand esticada joga a logo pro meio da tela e empurra os icones.
   Largura natural = logo encostada na esquerda. */
.app-header .navbar-brand {
  flex: 0 0 auto;
  width: 92px;
}
.app-header .navbar-nav {
  position: static !important;
  flex-shrink: 0;
}
/* Banner de aceite e o unico item largo e dispensavel: sai abaixo
   de 1200px pra caber todo o resto em 1 linha (era ele, nao a
   brand, que estourava a faixa 990-1175px). */
@media (max-width: 1199.98px) {
  .app-header h2 {
    display: none !important;
  }
}

/* Abaixo de 992px o overlay do cliente forca
   `#app.<cliente> .app-header .navbar-brand { width:100% !important }`
   (desenhado pra quando a brand era o unico item visivel no mobile).
   Com os icones visiveis, a brand de 100% empurra todos eles pra
   fora da viewport — o usuario ve o header sem nenhum botao.
   Aquele seletor tem ID, entao `width` com !important daqui perde;
   `max-width` nao tem regra concorrente e limita o 100% sem entrar
   na briga de especificidade. */
@media (max-width: 991.98px) {
  .app-header .navbar-brand {
    max-width: 92px;
    margin: 0 !important;
  }
}

/* Layout mobile do mockup: 1 linha só — hamburguer, ícones (sem
   tela cheia), logo, avatar. Gatilho por LARGURA só (max-width),
   sem depender de hover — detecção de touch se mostrou nao-
   confiavel (notebook com tela touch + mouse) e nao-verificavel
   nesta sessao de teste. Sino/idioma (d-sm-down-none) e banner de
   aceite (d-none d-md-block) ja saem por conta das classes deles.
   Cobre 375px (menor aparelho suportado) ate 767.98px: em ~580px o
   layout desktop ja nao cabia e os itens quebravam de linha. */
@media (max-width: 767.98px) {
  .app-header.navbar {
    background-color: #008144;
  }
  /* o tema legado poe `.app-header .navbar-toggler { position:absolute;
     left:0 }` em <=991.98px — fora do fluxo flex, `order` nao tem
     efeito e o ≡ fica POR CIMA do primeiro icone. Volta pro fluxo. */
  .app-header .mobile-sidebar-toggler {
    position: static !important;
    order: 1;
    flex-shrink: 0;
  }
  .app-header .header-icon-fullscreen {
    display: none;
  }
  /* `.nav` do Bootstrap e flex-wrap:wrap; se a ul puder encolher
     (flex-shrink:1) os <li> quebram pra segunda linha — era o
     "botoes indo pra cima". 0 0 auto + nowrap trava isso. */
  .app-header .navbar-nav.navbar-nav-icons {
    order: 2;
    flex: 0 0 auto;
    flex-wrap: nowrap;
  }
  .app-header .navbar-brand {
    order: 3;
    flex: 0 0 auto;
    max-width: 56px;
    margin: 0 !important;
    /* o overlay do cliente pede background-size:92px numa caixa que
       agora tem 56px — a logo saia cortada. contain cabe inteira. */
    background-size: contain !important;
  }
  .app-header .navbar-nav:not(.navbar-nav-icons) {
    order: 4;
    flex: 0 0 auto;
    flex-wrap: nowrap;
  }
  /* nav-item de 50px de largura minima do tema legado nao cabe 4x
     em 375px junto com logo e avatar */
  .app-header.navbar .navbar-nav-icons .nav-item {
    min-width: 38px;
  }
}

ul.dropdown-menu.show {
  min-width: 12rem;
}

.app-header.navbar .dropdown-item {
  min-width: 12rem;
}

.apps-download-dropdown .dropdown-menu {
  max-height: 13.2rem;
  overflow-y: auto;
}

img.flags {
  width: 40px;
}

.notification-card {
  border-bottom: 1px solid lightgray;
  border-top: 1px solid lightgray;
  margin: -.7em -1.1em;
}

.notification-card-date {
  font-size: xx-small;
  text-align: right;
  font-style: italic;
}

.notification-card-gradient {
  background: linear-gradient(to right, rgba(255,255,255,.5), rgba(202, 202, 202, 0.5), rgba(14, 126, 14, 0.5));
  background-size: 100% 100%;
  background-position: left top;
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/Header.vue